module.exports = __webpack_public_path__ + "static/media/glass_opendoor_right.eebf3683.png";